var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.95752,
    width: 29.4084,
    height: 29,
    rx: 5,
    fill: "#8A8C89"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07031 11.625C9.07031 10.7275 9.8081 10 10.7182 10H20.6055C21.5156 10 22.2534 10.7275 22.2534 11.625V18.125C22.2534 19.0225 21.5156 19.75 20.6055 19.75H10.7182C9.8081 19.75 9.07031 19.0225 9.07031 18.125V11.625ZM10.7182 10.8125C10.2631 10.8125 9.89426 11.1763 9.89426 11.625V11.8012L15.6619 15.2137L21.4295 11.8012V11.625C21.4295 11.1763 21.0606 10.8125 20.6055 10.8125H10.7182ZM21.4295 12.7488L17.5503 15.044L21.4295 17.398V12.7488ZM21.4017 18.3351L16.7543 15.5149L15.6619 16.1613L14.5695 15.5149L9.92208 18.3351C10.016 18.682 10.3368 18.9375 10.7182 18.9375H20.6055C20.9869 18.9375 21.3077 18.682 21.4017 18.3351ZM9.89426 17.398L13.7734 15.044L9.89426 12.7488V17.398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageTableIcon);
export default __webpack_public_path__ + "static/media/message-table-icon.0d689a3989bc5a0f265ede2311f27705.svg";
export { ForwardRef as ReactComponent };